<style>
    .options div:hover {
        @apply bg-blue-200;
    }
    .options {
        max-height: 20rem;
    }
</style>

<script>
    import { keydowns, clearOnEscape, buildSearch } from '../utils';
    import { createEventDispatcher, tick } from 'svelte';

    export let options = [];
    export let filter = '';

    $: filterRe = buildSearch(filter || '');
    $: filtered = options.filter(({ slug }) => slug.match(filterRe));

    let opened;
    let withMouse = false;
    let idx = 0;

    const dispatch = createEventDispatcher();

    $: {
        filter && (opened = true);
    }

    $: options, (idx = 0);
    $: idx && opened && scrollIntoOption();

    function scrollIntoOption() {
        document
            .getElementById(`option-${idx}`)
            .scrollIntoView({ block: 'nearest' });
    }

    function clearState() {
        idx = 0;
        opened = 0;
    }

    async function selectOption(option) {
        if (!option) return;
        withMouse = false;
        filter = option.nombre;
        dispatch('selected', option);
        await tick();
        clearState();
    }
</script>

<div class="relative" class:select-first="{!withMouse}">
    <input
        on:focus="{() => {
            filter = '';
            opened = true;
        }}"
        on:blur="{() => {
            if (withMouse) return;
            opened = false;
        }}"
        on:keydown.ArrowUp="{() => (idx = Math.max(0, idx - 1))}"
        on:keydown.ArrowDown="{() => (idx = Math.min(options.length, idx + 1))}"
        on:keydown.Enter="{selectOption(filtered[idx])}"
        class:rounded-b-none="{opened}"
        bind:value="{filter}"
        use:clearOnEscape
    />
    {#if opened}
        <div
            class="absolute z-10 w-full overflow-y-scroll bg-white border border-t-0 rounded-b options"
            on:mouseover="{() => (withMouse = true)}"
            on:mouseout="{() => (withMouse = false)}"
        >
            {#each filtered as option, index}
                <div
                    id="{`option-${index}`}"
                    on:click="{selectOption(option)}"
                    class="{`p-1 border-b ${option.cls}`}"
                    class:bg-blue-200="{!withMouse && index == idx}"
                >
                    {option.nombre}
                </div>
            {/each}
        </div>
    {/if}
</div>
